module.exports = __webpack_public_path__ + "static/img/kefu_online.1d8bd115.png";